//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js'

export default {
  name: 'index',
  mixins: [SEO, JSONSCHEMA],
  async asyncData({$api, error}) {
    try {
      const response = await $api.fetchCostPage()
      const page = response.content
      return {page}
    } catch (e) {
      error({statusCode: 500, message: 'Unable to fetch page content'})
    }
  },
};
